export { BusEventType } from './EventMap';
import type { EventMap } from './EventMap';
import { TypedEventBus } from './TypedEventBus';

export const eventBus = new TypedEventBus<EventMap>();
